import { render, staticRenderFns } from "./HeadingSettings.vue?vue&type=template&id=3b4d3890"
import script from "./HeadingSettings.vue?vue&type=script&lang=ts"
export * from "./HeadingSettings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b4d3890')) {
      api.createRecord('3b4d3890', component.options)
    } else {
      api.reload('3b4d3890', component.options)
    }
    module.hot.accept("./HeadingSettings.vue?vue&type=template&id=3b4d3890", function () {
      api.rerender('3b4d3890', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sale-layout-editor/HeadingSettings.vue"
export default component.exports